// import { hasAddressRequiredAttributes } from '@/js/helper/aimeos-basket-address-helper.js'
import { dispatchDeleteUrl } from '@/js/helper/aimeos-request-helper.js'
import { basketAddressCompare } from '@/js/helper/aimeos-basket-address-helper'
import { basketServiceCompare } from '@/js/helper/aimeos-basket-service-helper'
import { basketCustomerRefAndCommentCompare } from '@/js/helper/aimeos-basket-attribute-helper'

import { asyncForEach } from '@/js/helper/async-helper.js'
import axios from '@/js/helper/axios-helper.js'
import { get, head, isEmpty, isUndefined, cloneDeep } from 'lodash-es'
import { stringify } from 'qs'
import {
  API_CONSTANTS,
  AIMEOS_GETTER_TYPES,
  // CUSTOMER_GENERATED_GETTER_TYPES,
  CHECKOUT_MUTATION_TYPES,
  REQUEST_STATE,
  TYPES,
  STORE_MODULES,
  APP_GETTER_TYPES,
} from './std-imports'
import { CHECKOUT_CONSTANTS } from '../constants/checkout-constants'

import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'

export const getCheckoutApiActions = MUTATION_TYPES => ({
  [TYPES.SET_CHECKOUT_INFOS]: ({ commit }, { termsUrl, privacyUrl }) => {
    commit(CHECKOUT_MUTATION_TYPES.CHECKOUT_PRIVACY_URL, privacyUrl)
    commit(CHECKOUT_MUTATION_TYPES.CHECKOUT_TERMS_URL, termsUrl)
  },
  [TYPES.SELECT_DELIVERYADDRESS]: ({ commit }, { client, value }) => {
    commit(CHECKOUT_MUTATION_TYPES.DELIVERY_ADDRESS, { client, value })
  },
  [TYPES.SELECT_PAYMENT_SERVICE]: ({ commit }, id) => {
    commit(CHECKOUT_MUTATION_TYPES.PAYMENT_SERVICE, id)
  },
  [TYPES.SELECT_DELIVERY_SERVICE]: ({ commit }, id) => {
    commit(CHECKOUT_MUTATION_TYPES.DELIVERY_SERVICE, id)
  },
  [TYPES.SET_REFERENCE]: ({ commit }, { client = null, value }) => {
    commit(CHECKOUT_MUTATION_TYPES.REFERENCE, { client, value })
  },
  [TYPES.SET_COMMENT]: ({ commit }, { client = null, value }) => {
    commit(CHECKOUT_MUTATION_TYPES.COMMENT, { client, value })
  },
  [TYPES.BASKET_STEP_CONTINUE]: ({ dispatch }) => {
    return Promise.all([dispatch(TYPES.GET_CUSTOMER), dispatch(TYPES.GET_CLIENT)]).catch(e =>
      console.log(e),
    )
  },
  [TYPES.ADDRESS_STEP_CONTINUE]: ({ dispatch }) => {
    return Promise.all([dispatch(TYPES.SET_ADRESSES), dispatch(TYPES.GET_SERVICES)]).catch(e =>
      console.log(e),
    )
  },
  [TYPES.SERVICE_STEP_CONTINUE]: ({ dispatch }) => {
    return dispatch(TYPES.SET_SERVICES).catch(e => console.log(e))
  },
  [TYPES.ADDITIONALINFO_STEP_CONTINUE]: ({ dispatch }) => {
    return dispatch(TYPES.SET_ADDITIONALINFO).catch(e => console.log(e))
  },
  [TYPES.SUMMARY_STEP_CONTINUE]: ({ dispatch }) => {
    return dispatch(TYPES.SAVE_BASKET_AND_CREATE_ORDER).catch(e => console.log(e))
  },
  [TYPES.FAST_CHECKOUT_START]: async ({ dispatch }) => {
    // console.log('FAST_CHECKOUT_START')
    await Promise.all([
      dispatch(TYPES.GET_CUSTOMER),
      dispatch(TYPES.GET_CLIENT),
      dispatch(TYPES.GET_SERVICES),
    ]).catch(e => console.log(e))

    dispatch(TYPES.SET_CHECKOUT_FORM_FROM_BASKET).catch(e => console.log(e))
    await dispatch(TYPES.SET_INITIAL_ADDRESSES).catch(e => console.log(e))
    await dispatch(TYPES.SET_INITIAL_SERVICES).catch(e => console.log(e))
  },
  [TYPES.SET_CHECKOUT_FORM_FROM_BASKET]: async ({ commit, getters }) => {
    console.log(
      '🚀 ~ file: checkout-api-actions.js:75 ~ [TYPES.SET_CHECKOUT_FORM_FROM_BASKET]: ~ getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA]:',
      getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA],
    )
    commit(
      CHECKOUT_MUTATION_TYPES.CLIENT_DATA,
      cloneDeep(getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA]),
    )
    console.log(
      '🚀 ~ file: checkout-api-actions.js:75 ~ [TYPES.SET_CHECKOUT_FORM_FROM_BASKET]: ~ getters[AIMEOS_GETTER_TYPES.CLIENT_DATA]:',
      getters[AIMEOS_GETTER_TYPES.CLIENT_DATA],
    )
  },
  [TYPES.SET_INITIAL_ADDRESSES]: async ({ dispatch, getters, commit }) => {
    const clientDeliveryAddressesNeeded = getters[AIMEOS_GETTER_TYPES.BASKET_CLIENTS].filter(
      client =>
        !getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA_FOR](client)?.[
          CHECKOUT_CONSTANTS.DELIVERY_ADDRESS
        ],
    )
    getters[AIMEOS_GETTER_TYPES.BASKET_CLIENTS].forEach(client =>
      console.log(
        '🚀 ~ file: checkout-api-actions.js',
        getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA_FOR](client)?.[
          CHECKOUT_CONSTANTS.DELIVERY_ADDRESS
        ],
      ),
    )
    console.log(
      '🚀 ~ file: checkout-api-actions.js:78 ~ [TYPES.SET_INITIAL_ADDRESSES]: ~ clientDeliveryAddressesNeeded:',
      getters[AIMEOS_GETTER_TYPES.BASKET_CLIENTS],
      clientDeliveryAddressesNeeded,
    )
    // console.log('SET_INITIAL_ADDRESSES')
    // Do not overwrite existing address
    if (
      getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_ADDRESS] &&
      isEmpty(clientDeliveryAddressesNeeded)
    ) {
      return
    }
    const addressToBeSaved =
      getters[AIMEOS_GETTER_TYPES.CUSTOMER_DEFAULT_DELIVERY_ADDRESS] ||
      get(getters[AIMEOS_GETTER_TYPES.CUSTOMER_DELIVERY_ADDRESSES], 0)

    if (!addressToBeSaved) {
      Promise.reject(new Error(`No delivery address found!`))
    }

    getters[AIMEOS_GETTER_TYPES.BASKET_CLIENT_DATA]
    clientDeliveryAddressesNeeded.forEach(client => {
      commit(CHECKOUT_MUTATION_TYPES.DELIVERY_ADDRESS, {
        client,
        value: get(addressToBeSaved, API_CONSTANTS.ID),
      })
    })
    await dispatch(TYPES.SET_ADRESSES).catch(e => console.log(e))
    await dispatch(TYPES.SET_ADDITIONALINFO).catch(e => console.log(e))
  },
  [TYPES.SET_INITIAL_SERVICES]: async ({ dispatch, getters, commit }) => {
    // console.log('SET_INITIAL_SERVICES')
    const paymentServiceToBeSaved =
      getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_SERVICE_ID] ||
      get(head(getters[AIMEOS_GETTER_TYPES.SERVICE_PAYMENT_SERVICES]), API_CONSTANTS.ID)
    const deliveryServiceToBeSaved =
      getters[AIMEOS_GETTER_TYPES.BASKET_DELIVERY_SERVICE_ID] ||
      get(head(getters[AIMEOS_GETTER_TYPES.SERVICE_DELIVERY_SERVICES]), API_CONSTANTS.ID)

    if (!paymentServiceToBeSaved) {
      Promise.reject(new Error(`No payment service found!`))
    }
    if (!deliveryServiceToBeSaved) {
      Promise.reject(new Error(`No delivery service found!`))
    }
    commit(CHECKOUT_MUTATION_TYPES.PAYMENT_SERVICE, paymentServiceToBeSaved)
    commit(CHECKOUT_MUTATION_TYPES.DELIVERY_SERVICE, deliveryServiceToBeSaved)
    await dispatch(TYPES.SET_SERVICES)
  },
  [TYPES.SET_ADRESSES]: async ({ state, getters, dispatch }) => {
    await getters[AIMEOS_GETTER_TYPES.BASKET_PROMISE]

    const url = getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_ADDRESS_POST_URL]
    if (isUndefined(url)) {
      return Promise.reject(new Error(`Missing basket/address Url!`))
    }

    const billingAddress = getters[AIMEOS_GETTER_TYPES.CUSTOMER_PAYMENT_ADDRESS_BASKET]
    // const deliveryAddress = getters[AIMEOS_GETTER_TYPES.CUSTOMER_DELIVERY_ADDRESS_BASKET]

    if (isUndefined(billingAddress)) {
      return Promise.reject(new Error(`billing address has missing parts!`))
    }
    // if (isUndefined(deliveryAddress)) {
    //   return Promise.reject(new Error(`AIMEOS::delivery address undefined!`))
    // }

    try {
      let i = 0
      // let compareResult = basketAddressCompare({ getters, billingAddress, deliveryAddress })
      let compareResult = basketAddressCompare({ getters, billingAddress })

      console.log('Before:', { compareResult })
      while (i < 10 && !compareResult) {
        i += 1

        const deleteUrlEntries = [
          ...getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_PAYMENT_ADDRESS_DELETE_URL],
          // ...getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_DELIVERY_ADDRESS_DELETE_URL],
        ]
        if (deleteUrlEntries.length) {
          await asyncForEach(deleteUrlEntries, dispatchDeleteUrl(TYPES.BASKET_REQUEST, dispatch))
        }

        await dispatch(TYPES.BASKET_REQUEST, {
          method: 'POST',
          url,
          data: {
            // data: [billingAddress, deliveryAddress],
            data: [billingAddress],
          },
        })
        if (!getters[`${MUTATION_TYPES.BASKET.BASE}_${REQUEST_STATE.STATE_SUCCESS}`]) {
          return Promise.reject(new Error(state[MUTATION_TYPES.BASKET.errorMessageKey]))
        }
        await dispatch(TYPES.BASKET_REQUEST)
        compareResult = basketAddressCompare({ getters, billingAddress })
        // compareResult = basketAddressCompare({ getters, billingAddress, deliveryAddress })
        console.log('After:', { compareResult })
      }
      return compareResult
    } catch (error) {
      return Promise.reject(new Error(error.message))
    }
  },
  [TYPES.SET_SERVICES]: async ({ state, getters, dispatch }) => {
    await getters[AIMEOS_GETTER_TYPES.BASKET_PROMISE]

    const url = getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_SERVICE_POST_URL]
    if (isUndefined(url)) {
      return Promise.reject(new Error(`Missing basket/address Url!`))
    }

    const billingService = getters[AIMEOS_GETTER_TYPES.SERVICE_PAYMENT_SERVICE_BASKET]
    const deliveryService = getters[AIMEOS_GETTER_TYPES.SERVICE_DELIVERY_SERVICE_BASKET]

    if (isUndefined(billingService)) {
      return Promise.reject(new Error(`billing service undefined!`))
    }
    if (isUndefined(deliveryService)) {
      return Promise.reject(new Error(`delivery service undefined!`))
    }

    try {
      let i = 0
      let compareResult = basketServiceCompare({ getters })

      console.log('Before:', { compareResult })
      while (i < 10 && !compareResult) {
        i += 1

        const deleteUrlEntries = [
          ...getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_PAYMENT_SERVICE_DELETE_URL],
          ...getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_DELIVERY_SERVICE_DELETE_URL],
        ]
        if (deleteUrlEntries.length) {
          await asyncForEach(deleteUrlEntries, dispatchDeleteUrl(TYPES.BASKET_REQUEST, dispatch))
        }

        await dispatch(TYPES.BASKET_REQUEST, {
          method: 'POST',
          url,
          data: {
            data: [billingService, deliveryService],
          },
        })
        if (!getters[`${MUTATION_TYPES.BASKET.BASE}_${REQUEST_STATE.STATE_SUCCESS}`]) {
          return Promise.reject(new Error(state[MUTATION_TYPES.BASKET.errorMessageKey]))
        }
        await dispatch(TYPES.BASKET_REQUEST)
        compareResult = basketServiceCompare({ getters })
        console.log('After:', { compareResult })
      }
      return compareResult
    } catch (error) {
      return Promise.reject(new Error(error.message))
    }
  },
  [TYPES.SET_ADDITIONALINFO]: async ({ state, getters, dispatch }) => {
    await getters[AIMEOS_GETTER_TYPES.BASKET_PROMISE]

    // const url = getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_SELF_PATCH_URL] // '/api/jsonapi?ai%5Bresource%5D=basket&ai%5Bcontroller%5D=Jsonapi&ai%5Baction%5D=get' // getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_SELF_PATCH_URL]
    const url = getters[AIMEOS_GETTER_TYPES.OPTIONS_BASKET_URL]
    if (isUndefined(url)) {
      return Promise.reject(new Error(`AIMEOS::Missing basket self Url!`))
    }

    const infoData = getters[AIMEOS_GETTER_TYPES.CHECKOUT_ADDITONALINFO_BASKET]

    if (isUndefined(infoData)) {
      return Promise.resolve(true)
    }

    try {
      let i = 0
      let compareResult = basketCustomerRefAndCommentCompare({ getters })

      console.log('Before:', { compareResult })
      while (i < 10 && !compareResult) {
        i += 1
        console.log(`Save try: ${i}`)
        await dispatch(TYPES.BASKET_REQUEST, {
          method: 'PATCH',
          url,
          data: {
            data: infoData,
          },
        })
        if (!getters[`${MUTATION_TYPES.BASKET.BASE}_${REQUEST_STATE.STATE_SUCCESS}`]) {
          return Promise.reject(new Error(state[MUTATION_TYPES.BASKET.errorMessageKey]))
        }
        await dispatch(TYPES.BASKET_REQUEST)
        compareResult = basketCustomerRefAndCommentCompare({ getters })
        console.log('After:', { compareResult })
      }
      return true // Todo: Use compareResult ans show error message
    } catch (error) {
      return Promise.reject(new Error(error.message))
    }
  },
  [TYPES.SAVE_BASKET_AND_CREATE_ORDER]: async ({ state, getters, dispatch, rootGetters }) => {
    if (!rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_ORDER_W.p)) {
      return Promise.reject(new Error(`AIMEOS::No Permission ${DP_ROLE.SHOP_ORDER_W.p}`))
    }

    await getters[AIMEOS_GETTER_TYPES.BASKET_PROMISE]

    const url = getters[AIMEOS_GETTER_TYPES.OPTIONS_BASKET_URL]
    if (isUndefined(url)) {
      return Promise.reject(new Error(`AIMEOS::Missing basket self Url!`))
    }

    try {
      await dispatch(TYPES.BASKET_REQUEST, {
        method: 'POST',
        url,
      })
      if (!getters[`${MUTATION_TYPES.BASKET.BASE}_${REQUEST_STATE.STATE_SUCCESS}`]) {
        return Promise.reject(new Error(state[MUTATION_TYPES.BASKET.errorMessageKey]))
      }

      // CREATE ORDER
      const response = await dispatch(TYPES.CREATE_ORDER)
      return response
      // return dispatch(TYPES.REDIRECT_TO_PROCESS)
    } catch (error) {
      return Promise.reject(new Error(error.message))
    }
  },
  [TYPES.CREATE_ORDER]: async ({ commit, getters, rootGetters }) => {
    if (!rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_ORDER_W.p)) {
      return Promise.reject(new Error(`AIMEOS::No Permission ${DP_ROLE.SHOP_ORDER_W.p}`))
    }

    await getters[AIMEOS_GETTER_TYPES.BASKET_PROMISE]

    const url = getters[AIMEOS_GETTER_TYPES.BASKET_BASKET_ORDER_POST_URL]
    if (isUndefined(url)) {
      return Promise.reject(new Error(`AIMEOS::Missing basket order Url!`))
    }

    const orderData = getters[AIMEOS_GETTER_TYPES.CHECKOUT_CREATE_ORDER_DATA]
    if (isUndefined(orderData)) {
      return Promise.reject(new Error(`AIMEOS::Missing order base id!`))
    }

    const params = {
      method: 'POST',
      url,
      data: {
        data: orderData,
      },
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.ORDER.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.ORDER.urlKey], null)
        }

        commit(MUTATION_TYPES.ORDER.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        return Promise.reject(new Error(error.message))
      })

    commit(MUTATION_TYPES.ORDER.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  // [TYPES.REDIRECT_TO_PROCESS]: async ({ getters }) => {
  //   if (isUndefined(getters[AIMEOS_GETTER_TYPES.ORDER_PROCESS_URL])) {
  //     return Promise.reject(new Error(`AIMEOS::Missing process url!`))
  //   }

  //   return getters[AIMEOS_GETTER_TYPES.ORDER_PROCESS_URL]
  // },
  [TYPES.GET_CUSTOMER]: async ({ state, commit, getters }, refresh = false) => {
    console.log('GET_CUSTOMER')
    await getters[AIMEOS_GETTER_TYPES.OPTIONS_PROMISE]

    if (!getters[AIMEOS_GETTER_TYPES.OPTIONS_CUSTOMER_URL]) {
      return Promise.reject(new Error(`AIMEOS::Missing Options Url!`))
    }

    if (getters[`${MUTATION_TYPES.CUSTOMER.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.CUSTOMER.promiseKey]
    }

    if (getters[`${MUTATION_TYPES.CUSTOMER.BASE}_${REQUEST_STATE.STATE_SUCCESS}`] && !refresh) {
      return state[MUTATION_TYPES.CUSTOMER.promiseKey]
    }

    const promise = axios
      .get(
        `${getters[AIMEOS_GETTER_TYPES.OPTIONS_CUSTOMER_URL]}&${stringify({
          'ai[include]': 'customer/address',
        })}`,
      )
      .then(response => {
        commit(MUTATION_TYPES.CUSTOMER.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.BASKET.urlKey], null)
        }

        commit(MUTATION_TYPES.CUSTOMER.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // Todo: See above.. request basket again etc...?
        return Promise.reject(new Error(error.message))
      })

    commit(MUTATION_TYPES.CUSTOMER.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.GET_SERVICES]: async ({ state, commit, getters }) => {
    // console.log('GET_SERVICES')
    await getters[AIMEOS_GETTER_TYPES.OPTIONS_PROMISE]

    if (!getters[AIMEOS_GETTER_TYPES.OPTIONS_SERVICE_URL]) {
      return Promise.reject(new Error(`AIMEOS::Missing Options Url!`))
    }

    if (getters[`${MUTATION_TYPES.SERVICE.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.SERVICE.promiseKey]
    }

    if (getters[`${MUTATION_TYPES.SERVICE.BASE}_${REQUEST_STATE.STATE_SUCCESS}`]) {
      return state[MUTATION_TYPES.SERVICE.promiseKey]
    }

    const promise = axios
      .get(
        `${getters[AIMEOS_GETTER_TYPES.OPTIONS_SERVICE_URL]}&${stringify({
          'ai[include]': 'text',
        })}`,
      )
      .then(response => {
        commit(MUTATION_TYPES.SERVICE.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.BASKET.urlKey], null)
        }

        commit(MUTATION_TYPES.SERVICE.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // Todo: See above.. request basket again etc...?
        return Promise.reject(new Error(error.message))
      })

    commit(MUTATION_TYPES.SERVICE.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
})
